import React from 'react';
import ProductCommittedDetail from 'components/Tvendo/Sale/Operations/ProductCommitted/Detail.js';

export default function () {
  return <ProductCommittedDetail />;
}
